import { Route, Navigate, Outlet, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getRoleOfUser} from "../../api/userApiFunctions"
import { getUserID, isLoggedIn } from "../../Utility/service";
import { CustomSpinner } from "../common/CustomSpinner";
import { getAssistantInfo } from "../../api/assistantApiFunctions";

const ProtectedRoutes = () => {
  const [userRole, setUserRole] = useState(null);
  const [isPublic, setIsPublic] = useState(false);
  const [loading, setLoading] = useState(true);
  const [checkUser, setCheckUser] = useState(false);
  const [organizational, setIsOrganizational] = useState(false);

  const { assistant_id } = useParams();
  const userId = getUserID();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        // Fetch role of the user
        await getRoleOfUser(userId, setUserRole, setIsPublic);

        // Fetch assistant info
        await getAssistantInfo(userId, assistant_id, setCheckUser, setIsPublic, setIsOrganizational);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, assistant_id]);

  // While loading, show spinner
  if (loading) {
    return <CustomSpinner />;
  }

  // Access control logic
  if (checkUser || userRole === "superadmin" || isPublic || organizational) {
    return <Outlet />;
  }

  return isLoggedIn() ? <Navigate to="*" /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;